import axios from "axios"

const getUserWithToken = (token) => {
  const headers = {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`
  }
  return axios
    .get("/account/token", { headers })
    .then((response) => {
      //console.log("response from token auth", response.data.user.site)
      if (response.status == 200) {
        axios.defaults.headers.common["Authorization"] = `Bearer ${token}`
        axios.defaults.headers.common[
          "locale-id"
        ] = `${response.data.user.site.locales[0].id}`
        axios.defaults.headers.common[
          "domain"
        ] = `${response.data.user.site.domain}`
      }
      return response.data
    })
    .catch((/* response */) => {
      //acctions in case of error in server
      //console.log("rerrr", response)
      return null
    })
}
// ACA EL BODY SE VUELVE A FORMATEAR PARA QUE EL BACK FUNCIONE, PODRIA evitarse

const resetPassword = (username, pass, passVerified) => {
  //body
  const body = { username, password: pass, passwordVerified: passVerified }
  const headers = {
    "Content-Type": "application/json"
    //Authorization: `Bearer ${token}`,
  }

  return axios
    .post("/account/pass", body, {
      headers: headers
    })
    .then((response) => {
      //console.log("response from server", response.status, response.data)
      if (response.status == 200) {
        axios.defaults.headers.common[
          "Authorization"
        ] = `Bearer ${response.data.auth_token}`
      }
      return response.data
    })
    .catch((/* response */) => {
      //acctions in case of error in server
      //console.log("rerrr", response)
      return null
    })
}
const linkSite = (siteData) => {
  const headers = {
    "Content-Type": "application/json",
    "locale-id": siteData.locales[0].id
  }
  return axios
    .post("/sites", siteData, {
      headers: headers
    })
    .then((response) => {
      //console.log("response from server", response.status, response.data)
      axios.defaults.headers.common["locale-id"] = `${siteData.locales[0].id}`
      axios.defaults.headers.common["domain"] = `${siteData.domain}`
      return response.data
    })
    .catch((/* response */) => {
      //acctions in case of error in server
      //console.log("rerrr", response)
      return null
    })
}
const createAccount = (account) => {
  const headers = {
    "Content-Type": "application/json"
  }
  return axios
    .post("/account/create", account, {
      headers: headers
    })
    .then((response) => {
      //console.log("response from server", response.status, response.data)
      if (response.status == 200) {
        axios.defaults.headers.common[
          "Authorization"
        ] = `Bearer ${response.data.auth_token}`
      }
      return response.data
    })
    .catch((res) => {
      //acctions in case of error in server

      return { error: res.response.data }
    })
}
const logIn = (username, pass) => {
  //body
  const body = { username, password: pass }
  const headers = {
    "Content-Type": "application/json"
    //Authorization: `Bearer ${token}`,
  }

  return axios
    .post("/account/sign-in", body, {
      headers: headers
    })
    .then((response) => {
      //console.log("response from server", response.status, response.data)

      const initialLocaleId =
        localStorage.getItem("locale-id") ||
        response.data.user.site.locales[0].id

      if (response.status == 200) {
        axios.defaults.headers.common[
          "Authorization"
        ] = `Bearer ${response.data.auth_token}`
        axios.defaults.headers.common["locale-id"] = `${initialLocaleId}`
        axios.defaults.headers.common[
          "domain"
        ] = `${response.data.user.site.domain}`
      }
      return response.data
    })
    .catch((/* response */) => {
      //acctions in case of error in server
      //console.log("rerrr", response)
      return null
    })
}

export default {
  logIn,
  getUserWithToken,
  resetPassword,
  createAccount,
  linkSite
}
